import React from 'react';

import classNames from 'classnames/bind';
import styles from './InputOptions.scss';
const cx = classNames.bind(styles);

const InputOptions = React.memo(
  ({ name = '', data = {}, value = '', onChange }) => {
    return (
      <div className={cx('InputOptions', name)}>
        {data.options &&
          data.options.map((option, i) => {
            const checked = value === option.value;
            return (
              <div className={`item ${checked ? 'item-checked' : ''}`}>
                <input
                  id={option.id}
                  type={data.type}
                  name={name}
                  value={option.value}
                  checked={checked}
                  onChange={onChange}
                />
                <label htmlFor={option.id}>{option.name}</label>
              </div>
            );
          })}
      </div>
    );
  },
);

export default InputOptions;
